export const genId = () => Math.random().toString(36).slice(2);

export const normalizeFromInitial = (initialDoc) => {
  const items = [];
  (initialDoc?.data || []).forEach((block) => {
    if (block.dataType === "text") {
      items.push({
        id: block._id || genId(),
        type: "text",
        dataType: "text",
        textFormat: "html",
        textRaw: block?.textRaw ?? " ",
        textPlain: block?.textPlain ?? " ",
        text: [{ id: genId(), content: block?.textRaw ?? " " }],
      });
    } else if (block.dataType === "table") {
      items.push({
        id: block._id || genId(),
        type: "table",
        tableTitle: block.tableTitle || "Untitled Table",
        tableRow: Array.isArray(block.tableRow) ? block.tableRow.map((r) => ({ ...r })) : [],
        tableColumn: Array.isArray(block.tableColumn) ? block.tableColumn.map((c) => ({ ...c })) : [],
        tableType: block?.tableType ?? "table",
        table: block?.table ?? null,
        hasCellData: block?.tableType === "content",
      });
    }
  });
  return items;
};

export const cleanTableData = (di, section) => {
  if (section !== "Disclosures") return di;
  const hideKeys = ["issubrow", "isnewrow", "isnew", "name"];
  const filterObj = (obj) => {
    if (!obj) return obj;
    const newObj = { ...obj };
    Object.keys(newObj).forEach(key => {
      if (hideKeys.includes(key.toLowerCase())) {
        delete newObj[key];
      }
    });
    return newObj;
  };
  return {
    tableTitle: di.tableTitle,
    tableType: di.tableType,
    hasCellData: di.hasCellData,
    tableColumn: (di.tableColumn || []).filter(c => !hideKeys.includes((c.name || "").toLowerCase())),
    tableRow: (di.tableRow || []).map(filterObj),
    table: Array.isArray(di.table) ? di.table.map(filterObj) : di.table,
  };
};

export const normalizeText = (value) => String(value || "").trim().toLowerCase();

export const getSectionFromDeletedItem = (item) => {
  const categoryCandidates = [
    item?.category,
    item?.section,
    item?.statementType,
    item?.fsType,
    item?.type,
    item?.itemType,
  ]
    .filter(Boolean)
    .map(normalizeText);

  if (categoryCandidates.some((value) => value === "bs" || value === "balance sheet" || value === "balancesheet")) {
    return "BS";
  }
  if (categoryCandidates.some((value) => value === "pl" || value === "p&l statement" || value === "pnl statement" || value === "profit and loss")) {
    return "PL";
  }
  if (categoryCandidates.some((value) => value === "general notes" || value === "general note" || value === "generalnote")) {
    return "general notes";
  }
  if (categoryCandidates.some((value) => value === "disclosure" || value === "disclosures")) {
    return "disclosure";
  }
  if (categoryCandidates.some((value) => value === "bs notes" || value === "balance sheet notes")) {
    return "BS notes";
  }
  if (categoryCandidates.some((value) => value === "pl notes" || value === "p&l statement notes" || value === "pnl statement notes")) {
    return "PL notes";
  }
  return "";
};

export const getTabFromDeletedItem = (item) => {
  const explicitLevel = Number(item?.level ?? item?.deletedLevel ?? item?.hierarchyLevel);
  if ([1, 2, 3].includes(explicitLevel)) {
    return `Level ${explicitLevel}`;
  }

  if (item?.levelThreeID || item?.levelThreeName || item?.subGroupID || item?.subGroupName) {
    return "Level 3";
  }
  if (item?.levelTwoID || item?.levelTwoName || item?.noteGroupID || item?.noteGroupName) {
    return "Level 2";
  }
  if (item?.levelOneID || item?.levelOneName || item?.fsGroupID || item?.fsGroupName) {
    return "Level 1";
  }

  return item?.name || item?.title || "Untitled";
};

export const getTitleFromDeletedItem = (item) => {
  const levelTab = getTabFromDeletedItem(item);

  if (levelTab === "Level 3") {
    return (
      item?.name ||
      item?.title ||
      item?.levelThreeName ||
      item?.subGroupName ||
      item?.sub_grp ||
      "Untitled"
    );
  }

  if (levelTab === "Level 2") {
    return (
      item?.name ||
      item?.title ||
      item?.levelTwoName ||
      item?.noteGroupName ||
      item?.note_grp ||
      "Untitled"
    );
  }

  if (levelTab === "Level 1") {
    return (
      item?.name ||
      item?.title ||
      item?.levelOneName ||
      item?.fsGroupName ||
      item?.fs_grp ||
      "Untitled"
    );
  }

  return item?.name || item?.title || "Untitled";
};
